// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, div, canvas {
    margin: 0;
    padding: 0;
}

h1 {
    font-family: Arial, serif;
    font-weight: 700;
    font-size: 1.2rem;
    margin-top: 2rem;
    margin-bottom: 0.5rem;
}

h2 {
    font-family: Arial, serif;
    font-weight: 700;
    font-size: 1rem;
    margin-top: 1rem;
    margin-bottom: 0;
}

.key_button {
    height: 2rem;
    width: auto;
    min-width: 4rem;
    font-size: 1rem;
    font-weight: 700;
    margin-top: 1rem;
}

#settings_form {
    margin-left: 1rem;
}

.horizontal-margin {
    margin-left: 1rem;
    margin-right: 1rem;
}

#log {
    background-color: #c0bec0;
    padding: 0.5rem;
}

p, #log {
    padding: 0.25rem;
    margin: 0;
}

.separator {
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/demo/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["html, body, div, canvas {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nh1 {\r\n    font-family: Arial, serif;\r\n    font-weight: 700;\r\n    font-size: 1.2rem;\r\n    margin-top: 2rem;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\nh2 {\r\n    font-family: Arial, serif;\r\n    font-weight: 700;\r\n    font-size: 1rem;\r\n    margin-top: 1rem;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.key_button {\r\n    height: 2rem;\r\n    width: auto;\r\n    min-width: 4rem;\r\n    font-size: 1rem;\r\n    font-weight: 700;\r\n    margin-top: 1rem;\r\n}\r\n\r\n#settings_form {\r\n    margin-left: 1rem;\r\n}\r\n\r\n.horizontal-margin {\r\n    margin-left: 1rem;\r\n    margin-right: 1rem;\r\n}\r\n\r\n#log {\r\n    background-color: #c0bec0;\r\n    padding: 0.5rem;\r\n}\r\n\r\np, #log {\r\n    padding: 0.25rem;\r\n    margin: 0;\r\n}\r\n\r\n.separator {\r\n    margin-bottom: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
